import { action, makeObservable, observable } from 'mobx';
import { Injectable } from './service.base';
import { ILinkAccount } from '~/views/types';

@Injectable()
export class VerificationCodeDialogService {
    @observable public open = false;
    @observable public showLoading = false;

    private linkAccount: ILinkAccount = {};

    constructor() {
        makeObservable(this);
    }

    @action
    handleOpen = () => {
        this.open = true;
    };

    @action
    handleClose = () => {
        this.open = false;
    };

    @action
    setShowLoading = (value: boolean) => {
        this.showLoading = value;
    };
}
